import { Link } from '@tanstack/react-router'
import { Compass, SearchX } from 'lucide-react'

import { EmptyState } from '@/components/kit/empty-state'
import { Page } from '@/components/kit/page'
import { Button } from '@/components/ui/button'
import { formatBinding } from '@/hooks/use-hotkeys'

/**
 * The two ways an operator lands here are a stale bookmark from the old Nuxt app
 * and a mistyped id, so the copy points at the two things that actually resolve
 * those: the palette for a lookup, and home for the route list.
 */
export function NotFoundComponent() {
    return (
        <Page>
            <EmptyState
                icon={SearchX}
                title="That page does not exist"
                description={
                    <>
                        The address may be from the previous admin, or an id in it may be wrong. Press{' '}
                        <kbd className="kbd-hint">{formatBinding('mod+k')}</kbd> to search for a record, or start from
                        the list of pages.
                    </>
                }
                action={
                    <Button variant="outline" size="sm" asChild>
                        <Link to="/">
                            <Compass />
                            Back to home
                        </Link>
                    </Button>
                }
            />
        </Page>
    )
}
